import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getReportDetails, doReportCreate, doReportUpdate 
} from "../../../../redux/report/reportState";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";

const { TextArea } = Input;

const ReportForm = ({getRecord, doCreate, doUpdate, recordData, requesting, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){
			const initialValues = {
				rpt_id: recordData.rpt_id,
				rpt_title: recordData.rpt_title,
			    rpt_description: recordData.rpt_description,
			    rpt_service: recordData.rpt_service,
			    rpt_account_id: recordData.rpt_account_id,
			    rpt_status_id: recordData.rpt_status_id,
			    rpt_module_id: recordData.rpt_module_id,
			};	
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (values) => {	
    	try {  
			recordData.rpt_id > 0 ? doUpdate(values): doCreate(values); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="rpt_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>			    
			    <FormItem
			        name="rpt_account_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
        		<div className="grid grid-cols-4 gap-4">
	            	<FormItem className="font-medium mb-2"
		            	name="rpt_title"
		                label="Title"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Input id="rpt_title"/>
		                : <label className="ps-3 dark:text-white">{recordData?.rpt_title}</label>
		                }
	            	</FormItem>		            	
	            	<FormItem className="font-medium mb-2"
		            	name="rpt_service"
		                label="Service"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Input id="rpt_service"/>
		                : <label className="ps-3 dark:text-white">{recordData?.rpt_service}</label>
		                }
	            	</FormItem>		            	
	            	<FormItem className="font-medium mb-2"
		            	name="rpt_module_id"
		                label="Module ID"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Input id="rpt_module_id"
		            		style={{
						        width: 150,
						        textAlign: 'right',
						      }}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.rpt_module_id}</label>
		                }
	            	</FormItem>
	            	<FormItem className="font-medium mb-2"
		            	name="rpt_status_id"
		                label="Status"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="rpt_status_id"
		            		style={{
						        width: 150,
						      }}
					      	options={[]}
		            	/>		            		
		                : <label className="ps-3 dark:text-white">{recordData?.rpt_status_id}</label>
		                }
	            	</FormItem>
	            	<FormItem className="font-medium  mb-2 col-span-2"
		            	name="rpt_description"
		                label="Description"
		                initialValue={recordData?.rpt_description}
		            >
		            	{mode === 'edit' ?
		            	<TextArea className="py-2"
		            		rows={2}
		            		
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.rpt_description}</label>
		                }
	            	</FormItem>	            	
	 			</div>	 	
	 			<CrudButtons baseRoute="/console/salary-additions" mode={mode} recordId={recordData?.rpt_id} />			 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.report.reportDetails?.data,
  	requesting: state.report.reportDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getReportDetails(id)),
  	doCreate: (data) => dispatch(doReportCreate(data)),
  	doUpdate: (data) => dispatch(doReportUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportForm);
